export class UserModel {
	_id: string;
	// FirstName: string;
	// LastName: string;
	// Username: string;
	DisplayName: string;
	// Username: string;
	// MobileNumber: string;
	// Sex: string;
	// Birthdate: string;
	Email: string;
	// IdentificationNo: string;
	// IdentifierType: string;
	// RegisterDate: string;
	// UserType: string;
	Roles: string[];
	Groups: string[];
	constructor() {
		this.Roles = [];
		this.Groups = [];
	}
}
